export default __webpack_public_path__ + "static/media/violet.d8b65c5e.png";